/*
 * Copyright (C) 2018 BarD Software s.r.o
 */
import {SetIdToken, SignOut, Signup} from '../Routes';
import * as FirebaseAuth from './FirebaseAuth';
import {reactive} from 'vue';

import $ from 'jquery';

let FirebaselessAuth;

/** Id of the signed-in user, filled by the dashboard once the user is loaded.
 *  Unlike window.currentUserId, templates that read it re-render when it is set. */
export const currentUser = reactive({id: ''});

export interface User {
    id(): string;
    idToken(): Promise<string>;
    displayName(): string;
    email(): string | null;
    isEmailVerified(): boolean;
    sendEmailVerification(redirectUrl: string): Promise<void>;
    isEmailAuth(): boolean;
}

/**
 * @param redirect whether to leave for the landing page afterwards. The sign-in page passes false:
 * it drops the Firebase session to let a second account be started, and goes to its own page for that.
 */
export function signOut(redirect = true): Promise<void> {
    // The backend authenticates requests by the uid remembered in the session, so dropping the
    // Firebase credential in the browser is not enough: we ask it to invalidate the session too.
    // A failure here must not keep the user signed in in the browser, hence the catch.
    return Promise.resolve(SignOut.invoke(undefined))
        .catch((e) => console.error(e))
        .then(() => {
            if (FirebaselessAuth) {
                return FirebaselessAuth.signOut(redirect);
            }

            return FirebaseAuth.signOut(redirect);
        });
}

export function deleteCurrentUser(): Promise<void> {
    if (FirebaselessAuth) {
        return FirebaselessAuth.deleteCurrentUser();
    }

    return FirebaseAuth.deleteCurrentUser();
}

export function reauthenticateWithEmail(email: string, password: string): Promise<void> {
    if (FirebaselessAuth) {
        return Promise.resolve();
    }
    return FirebaseAuth.reauthenticateWithEmail(email, password);
}

function getUserOrUndefined(): User | undefined {
    if (FirebaselessAuth && FirebaselessAuth.getUser()) {
        return FirebaselessAuth.getUser();
    }

    return FirebaseAuth.getUser();
}

export function getUser(): User {
    const user = getUserOrUndefined();

    if (user === undefined) {
        Signup.redirect();
    } else {
        return user;
    }

}

export function init(): Promise<User> {
    return import('./FirebaselessAuth').then((m) => {
        const devUser = m.getUser();
        if (devUser !== undefined) {
            FirebaselessAuth = m;
            SetIdToken.invoke({
                user: devUser.id(),
            });
            return Promise.resolve(devUser);
        } else {
            throw Error('Firebaseless user not found.');
        }
    }).catch(() => FirebaseAuth.init());
}

$('.btn-logout').on('click', () => signOut());
